export default function Loading() {
  return (
    <div className="loading-main">
      <img src="assets/images/spinner.gif" alt="loading..." />
    </div>
  );
}
